async function createUserProfileStartTimeIndex(gymStateDb: any, logger: any) {
  logger.info('recreating userProfileId and startTime index');
  await gymStateDb.createIndex({
    index: {
      fields: ['userProfileId', 'startTime'],
      name: 'userProfileIdAndStartTimeIndex',
      ddoc: 'userProfileIdAndStartTimeIndex',
    },
  });
}

async function createUserProfileEndTimeIndex(gymStateDb: any, logger: any) {
  logger.info('recreating userProfileId and endTime index');
  await gymStateDb.createIndex({
    index: {
      fields: ['userProfileId', 'endTime'],
      name: 'userProfileIdAndEndTimeIndex',
      ddoc: 'userProfileIdAndEndTimeIndex',
    },
  });
}

async function createStartTimeIndex(gymStateDb: any, logger: any) {
  logger.info('recreating startTime index');
  await gymStateDb.createIndex({
    index: {
      fields: ['startTime'],
      name: 'startTimeOnlyIndex',
      ddoc: 'startTimeOnlyIndex',
    },
  });
}

async function createGymNameAndStartTimeIndex(gymStateDb: any, logger: any) {
    logger.info('recreating gym name and startTime index');
    await gymStateDb.createIndex({
        index: {
          fields: ['gymName', 'startTime'],
          name: 'gymNameAndStartTimeIndex',
          ddoc: 'gymNameAndStartTimeIndex',
        },
    });
}

async function createMemberMainGymAndStartTime(gymStateDb: any, logger: any) {
  logger.info('recreating member main gym and start time');
  await gymStateDb.createIndex({
      index: {
        fields: ['memberMainGym', 'startTime'],
        name: 'memberMainGymAndStartTimeIndex',
        ddoc: 'memberMainGymAndStartTimeIndex',
      },
  });
}

async function createRemovedAtCheckedInStartTimeIndex(gymStateDb: any, logger: any) {
  logger.info('recreating startTime index');
  await gymStateDb.createIndex({
    index: {
      fields: ['removedAt', 'checkedIn', 'startTime'],
      name: 'removedAtCheckedInStartTime',
      ddoc: 'removedAtCheckedInStartTime',
    },
  });
}

async function createWorkoutMarkedAsCompletedAtRemovedAtCheckedInEndTime(gymStateDb: any, logger: any) {
  logger.info('recreating createWorkoutMarkedAsCompletedAtRemovedAtCheckedInEndTime index');
  await gymStateDb.createIndex({
    index: {
      fields: ['workoutMarkedAsCompletedAt', 'removedAt', 'checkedIn', 'endTime'],
      name: 'workoutMarkedAsCompletedAtRemovedAtCheckedInEndTime',
      ddoc: 'workoutMarkedAsCompletedAtRemovedAtCheckedInEndTime',
    },
  });
}

async function createEndTimeIndex(gymStateDb: any, logger: any) {
  logger.info('recreating endTime index');
  await gymStateDb.createIndex({
    index: {
      fields: ['endTime'],
      name: 'endTimeIndex',
      ddoc: 'endTimeIndex',
    },
  });
}

export async function createBodyScanEmailTimeIndex(usersDb: any, logger: any) {
  logger.info('creating body scan email index');
  await usersDb.createIndex({
    index: {
      fields: ['testTime', 'userEmail'],
      name: 'bodyScanEmailTimeIndex',
      ddoc: 'bodyScanEmailTimeIndex',
    },
  });
}

async function createUserIdEndTimeAndRemovedAtIndex(gymStateDb: any, logger: any) {
  logger.info('recreating UserIdEndTimeAndRemovedAtIndex');
  await gymStateDb.createIndex({
    index: {
      fields: ['userProfileId', 'removedAt', 'endTime'],
      name: 'userIdEndTimeAndRemovedAtIndex',
      ddoc: 'userIdEndTimeAndRemovedAtIndex',
    },
  });
}

async function createUserIdEndTimeAndRemovedBookingStateAtIndex(gymStateDb: any, logger: any) {
  logger.info('recreating UserIdEndTimeAndRemovedBookingStateAtIndex');
  await gymStateDb.createIndex({
    index: {
      fields: ['userProfileId', 'removedAt', 'bookingState', 'endTime'],
      name: 'userIdEndTimeAndRemovedBookingStateAtIndex',
      ddoc: 'userIdEndTimeAndRemovedBookingStateAtIndex',
    },
  });
}

async function createEndTimeAndRemovedAtIndex(gymStateDb: any, logger: any) {
  logger.info('recreating UserIdEndTimeAndRemovedAtIndex');
  await gymStateDb.createIndex({
    index: {
      fields: ['removedAt', 'endTime'],
      name: 'endtimeAndRemovedAtIndex',
      ddoc: 'endtimeAndRemovedAtIndex',
    },
  });
}

async function createExpiresAtIndex(gymStateDb: any, logger: any) {
  logger.info('recreating expiresAt index');
  await gymStateDb.createIndex({
    index: {
      fields: ['expiresAt'],
    },
  });
}

async function createWaitingListEndTimeIndex(waitinglistDb: any, logger: any) {
  await waitinglistDb.createIndex({
    index: {
      name: 'endTimeIndex',
      ddoc: 'endTimeIndex',
      fields: ['timeSlot.endTime'],
    },
  });
}

async function createWaitingListStartTimeEndTimeWorkoutTypeIndex(waitinglistDb: any, logger: any) {
  logger.info('creating waitingListStartTimeEndTimeWorkoutTypeIndex');
  await waitinglistDb.createIndex({
    index: {
      fields: [
        'timeSlot.startTime',
        'timeSlot.endTime',
        'timeSlot.workoutType',
      ],
    },
  });
}

async function createWaitingListUserIdIndex(waitinglistDb: any, logger: any) {
  logger.info('creating waiting list user profile id');
  await waitinglistDb.createIndex({
    index: {
      fields: ['userProfile.uid'],
    },
  });
}

async function createUserProfileGymNameIndex(usersDb: any, logger: any) {
  logger.info('creating user profile gymname index');
  await usersDb.createIndex({
    index: {
      fields: ['gymName'],
      name: 'userProfileGymNameIndex',
      ddoc: 'userProfileGymNameIndex',
    },
  });
}

async function createUserProfileUsernameIndex(usersDb: any, logger: any) {
  logger.info('creating user profile username index');
  await usersDb.createIndex({
    index: {
      fields: ['username'],
    },
  });
}

async function createStripeUserIdIndex(usersDb: any, logger: any) {
  logger.info('creating stripe user id index');
  await usersDb.createIndex({
    index: {
      fields: ['stripeUserId'],
      name: 'userProfileStripeUserIdIndex',
      ddoc: 'userProfileStripeUserIdIndex',
    },
  });
}

async function createEmailUserIndex(usersDb: any, logger: any) {
  logger.info('creating email index');
  await usersDb.createIndex({
    index: {
      fields: ['email'],
      name: 'userProfileEmailIndex',
      ddoc: 'userProfileEmailIndex',
    },
  });
}

async function createUserHeartRateBeltIndex(usersDb: any, logger: any) {
  logger.info('creating heart rate beld index');
  await usersDb.createIndex({
    index: {
      fields: ['heartRateMonitorIdentifier'],
      name: 'heartRateMonitorIdentifierIndex',
      ddoc: 'heartRateMonitorIdentifierIndex',
    },
  });
}

async function createUserProfileNicknameIndex(usersDb: any, logger: any) {
  logger.info('creating user profile nickname index');
  await usersDb.createIndex({
    index: {
      fields: ['nickname'],
    },
  });
}

async function createUserProfileFullnameIndex(usersDb: any, logger: any) {
  logger.info('creating user profile fullname index');
  await usersDb.createIndex({
    index: {
      fields: ['fullname'],
    },
  });
}

async function createRemovedAtGymNameWorkoutTypeBookingStateIndex(gymStateDb: any, logger: any) {
  logger.info('recreating RemovedAtGymNameWorkoutTypeBookingStateIndex');
  await gymStateDb.createIndex({
    index: {
      fields: ['bookingState', 'removedAt', 'gymName', 'workoutType', 'performanceMetrics'],
      name: 'removedAtGymNameWorkoutTypeBookingStateIndex',
      ddoc: 'removedAtGymNameWorkoutTypeBookingStateIndex',
    },
  });
}

export async function createBodyScanUidTimeIndex(usersDb: any, logger: any) {
  logger.info('creating body scan uid index');
  await usersDb.createIndex({
    index: {
      fields: process.env.TESTS ? ['testTime', 'uid'] : ['uid', 'testTime'], // pouch weirdness
      name: 'bodyScanUidTimeIndex',
      ddoc: 'bodyScanUidTimeIndex',
    },
  });
}
export async function createBranchIndex(usersDb: any, logger: any) {
  logger.info('creating branch index');
  await usersDb.createIndex({
    index: {
      fields: ['branch'],
      name: 'branchIndex',
      ddoc: 'branchIndex',
    },
  });
}

async function createGymNameIndex(usersDb: any, logger: any) {
  logger.info('creating gym namw index');
  await usersDb.createIndex({
    index: {
      fields: ['gymName'],
      name: 'gymNameIndex',
      ddoc: 'gymNameIndex',
    },
  });
}

async function createUserMealsIndex(mealPlanDb: any, logger: any) {
  logger.info('creating meal plan index');
  await mealPlanDb.createIndex({
    index: {
      fields: [
        'userId',
        'dietGoal',
        'foodPreference',
        'gender',
      ],
      name: 'userMealPlan',
      ddoc: 'userMealPlan',
    },
  });
}

async function createInfluencerSettingsMediumIndex(usersDb: any, logger: any) {
  logger.info('creating influencer settings medium');
  await usersDb.createIndex({
    index: {
      fields: [
        'influencerSettings.utmTags.medium',
      ],
      name: 'medium',
      ddoc: 'influencer-settings',
    },
  });
}

async function createTrialExpiredIndex(usersDb: any, logger: any) {
  logger.info('creating trial expire index');
  await usersDb.createIndex({
    index: {
      fields: [
        'currentPlanId',
        'currentPlanStatus',
        'currentPlanCancelAtEndOfTerm',
        'currentPlanExpiresAt',
      ],
      name: 'trialExpiredIndex',
      ddoc: 'trialExpiredIndex',
    },
  });
}

async function createReviewNotifyIndex(gymstateDb: any, logger: any) {
  logger.info('creating review notify index');
  await gymstateDb.createIndex({
    index: {
      fields: [
        'removedAt',
        'anonymised',
        'reviewNotified',
        'endTime',
      ],
      name: 'reviewNotifyIndex',
      ddoc: 'reviewNotifyIndex',
    },
  });
}

export async function createAllGymStateIndexes(gymStateDb: any, logger: any) {
    logger.info('recreating all gym state indexes');
    const indexes = [
        createGymNameAndStartTimeIndex,
        createMemberMainGymAndStartTime,
        createUserProfileStartTimeIndex,
        createExpiresAtIndex,
        createStartTimeIndex,
        createEndTimeIndex,
        createReviewNotifyIndex,
        createUserProfileEndTimeIndex,
        createUserIdEndTimeAndRemovedAtIndex,
        createEndTimeAndRemovedAtIndex,
        createUserIdEndTimeAndRemovedBookingStateAtIndex,
        createRemovedAtGymNameWorkoutTypeBookingStateIndex,
        createRemovedAtCheckedInStartTimeIndex,
        createWorkoutMarkedAsCompletedAtRemovedAtCheckedInEndTime,
    ];

    for (const indexFunction of indexes) {
        await indexFunction(gymStateDb, logger);
    }
}

export async function createAllWaitingListIndexes(waitingListDb: any, logger: any) {
  logger.info('recreating all waiting list indexes');
  const indexes = [
    createWaitingListStartTimeEndTimeWorkoutTypeIndex,
    createWaitingListUserIdIndex,
    createWaitingListEndTimeIndex,
  ];

  for (const indexFunction of indexes) {
    await indexFunction(waitingListDb, logger);
  }
}

export async function createAllUserProfileIndexes(userDb: any, logger: any) {
  logger.info('recreating all user profile indexes');
  const indexes = [
    createUserProfileFullnameIndex,
    createUserProfileNicknameIndex,
    createUserProfileUsernameIndex,
    createStripeUserIdIndex,
    createEmailUserIndex,
    createUserHeartRateBeltIndex,
    createBranchIndex,
    createTrialExpiredIndex,
    createInfluencerSettingsMediumIndex,
    createUserProfileGymNameIndex,
  ];

  for (const indexFunction of indexes) {
    await indexFunction(userDb, logger);
  }
}

export async function createAllBodyScanIndexes(bodyScanDb: any, logger: any) {
  logger.info('recreating all body scan indexes');
  const indexes = [
    createBodyScanUidTimeIndex,
    createBodyScanEmailTimeIndex,
  ];

  for (const indexFunction of indexes) {
    await indexFunction(bodyScanDb, logger);
  }
}

export async function createAllMealPlanIndexes(mealPlanDb: any, logger: any) {
  logger.info('recreating meal plan indexes');
  const indexes = [
    createUserMealsIndex,
  ];

  for (const indexFunction of indexes) {
    await indexFunction(mealPlanDb, logger);
  }
}

export async function createAllAlertIndexes(alertsDb: any, logger: any) {
  logger.info('recreating all alert indexes');
  const indexes = [
    createGymNameIndex,
  ];

  for (const indexFunction of indexes) {
    await indexFunction(alertsDb, logger);
  }
}
